<div *ngIf="templates" class="row">
  <div
    class="col-6 col-md-4 col-xl-2 relative"
    [ngClass]="templates[0].flushed ? 'flushed' : 'no-flush'"
    [ngSwitch]="templates[0].typeOf"
  >
    <cta *ngSwitchCase="'cta'" [cta]="templates[0]" style="width: 100%"></cta>
    <image-block *ngSwitchCase="'image'" [imgblock]="templates[0]"></image-block>
    <app-feedback *ngSwitchCase="'feedback'" [feed]="templates[0]"></app-feedback>
    <showcase
      *ngSwitchCase="'showcase'"
      [showcase]="templates[0]"
      [dynamic]="true"
      [slideCount]="2"
    ></showcase>
    <text-block *ngSwitchCase="'text'" [textBlock]="templates[0]"></text-block>
    <topic-search *ngSwitchCase="'topic'" [topicSearch]="templates[0]"></topic-search>

    <ng-container *ngIf="edit">
      <div *ngSwitchCase="'edit'" class="choose-component">
        <select
          #select1
          title="Edit a Component"
          class="form-control"
          (change)="openSideNav(select1.value, 0, templates, 'col-632', false)"
        >
          <option value="0">--Choose--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </ng-container>
    <div *ngSwitchDefault></div>

    <!-- CREATE A ROLLVER EDIT SECTION -->
    <div *ngIf="edit && templates[0].typeOf !== 'edit'" class="edit-component text-center">
      <div class="edit-existing">
        <a
          tabindex="0"
          (click)="openSideNav(templates[0].typeOf, 0, templates, 'col-632', true)"
          (keyup.enter)="openSideNav(templates[0].typeOf, 0, templates, 'col-632', true)"
          >Edit Component</a
        >
        <div class="edit-or">- OR -</div>
        <select
          #select1
          title="Choose a Component"
          class="form-control"
          (change)="openSideNav(select1.value, 0, templates, 'col-632', false)"
        >
          <option value="0">--Choose New--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div
    class="col-6 col-md-4 col-xl-2 relative"
    style="margin-bottom: 10px"
    [ngClass]="templates[1].flushed ? 'flushed' : 'no-flush'"
    [ngSwitch]="templates[1].typeOf"
  >
    <cta *ngSwitchCase="'cta'" [cta]="templates[1]" style="width: 100%"></cta>
    <image-block *ngSwitchCase="'image'" [imgblock]="templates[1]"></image-block>
    <app-feedback *ngSwitchCase="'feedback'" [feed]="templates[1]"></app-feedback>
    <showcase
      *ngSwitchCase="'showcase'"
      [showcase]="templates[1]"
      [dynamic]="true"
      [slideCount]="2"
    ></showcase>
    <text-block *ngSwitchCase="'text'" [textBlock]="templates[1]"></text-block>
    <topic-search *ngSwitchCase="'topic'" [topicSearch]="templates[1]"></topic-search>

    <ng-container *ngIf="edit">
      <div *ngSwitchCase="'edit'" class="choose-component">
        <select
          #select2
          title="Edit a Component"
          class="form-control"
          (change)="openSideNav(select2.value, 1, templates, 'col-632', false)"
        >
          <option value="0">--Choose--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </ng-container>
    <div *ngSwitchDefault></div>

    <!-- CREATE A ROLLVER EDIT SECTION -->
    <div *ngIf="edit && templates[1].typeOf !== 'edit'" class="edit-component text-center">
      <div class="edit-existing">
        <a
          tabindex="0"
          (click)="openSideNav(templates[1].typeOf, 1, templates, 'col-632', true)"
          (keyup.enter)="openSideNav(templates[1].typeOf, 1, templates, 'col-632', true)"
          >Edit Component</a
        >
        <div class="edit-or">- OR -</div>
        <select
          #select2
          title="Choose a Component"
          class="form-control"
          (change)="openSideNav(select2.value, 1, templates, 'col-632', false)"
        >
          <option value="0">--Choose New--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div
    class="col-6 col-md-4 col-xl-2 relative"
    style="margin-bottom: 10px"
    [ngClass]="templates[2].flushed ? 'flushed' : 'no-flush'"
    [ngSwitch]="templates[2].typeOf"
  >
    <cta *ngSwitchCase="'cta'" [cta]="templates[2]" style="width: 100%"></cta>
    <image-block *ngSwitchCase="'image'" [imgblock]="templates[2]"></image-block>
    <app-feedback *ngSwitchCase="'feedback'" [feed]="templates[2]"></app-feedback>
    <showcase
      *ngSwitchCase="'showcase'"
      [showcase]="templates[2]"
      [dynamic]="true"
      [slideCount]="2"
    ></showcase>
    <text-block *ngSwitchCase="'text'" [textBlock]="templates[2]"></text-block>
    <topic-search *ngSwitchCase="'topic'" [topicSearch]="templates[2]"></topic-search>

    <ng-container *ngIf="edit">
      <div *ngSwitchCase="'edit'" class="choose-component">
        <select
          #select3
          title="Edit a Component"
          class="form-control"
          (change)="openSideNav(select3.value, 2, templates, 'col-632', false)"
        >
          <option value="0">--Choose--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </ng-container>
    <div *ngSwitchDefault></div>

    <!-- CREATE A ROLLVER EDIT SECTION -->
    <div *ngIf="edit && templates[2].typeOf !== 'edit'" class="edit-component text-center">
      <div class="edit-existing">
        <a
          tabindex="0"
          (click)="openSideNav(templates[2].typeOf, 2, templates, 'col-632', true)"
          (keyup.enter)="openSideNav(templates[2].typeOf, 2, templates, 'col-632', true)"
        >
          Edit Component
        </a>
        <div class="edit-or">- OR -</div>
        <select
          #select3
          title="Choose a Component"
          class="form-control"
          (change)="openSideNav(select3.value, 2, templates, 'col-632', false)"
        >
          <option value="0">--Choose New--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div
    class="col-6 col-md-4 col-xl-2 relative"
    style="margin-bottom: 10px"
    [ngClass]="templates[3].flushed ? 'flushed' : 'no-flush'"
    [ngSwitch]="templates[3].typeOf"
  >
    <cta *ngSwitchCase="'cta'" [cta]="templates[3]" style="width: 100%"></cta>
    <image-block *ngSwitchCase="'image'" [imgblock]="templates[3]"></image-block>
    <app-feedback *ngSwitchCase="'feedback'" [feed]="templates[3]"></app-feedback>
    <showcase
      *ngSwitchCase="'showcase'"
      [showcase]="templates[3]"
      [dynamic]="true"
      [slideCount]="2"
    ></showcase>
    <text-block *ngSwitchCase="'text'" [textBlock]="templates[3]"></text-block>
    <topic-search *ngSwitchCase="'topic'" [topicSearch]="templates[3]"></topic-search>

    <ng-container *ngIf="edit">
      <div *ngSwitchCase="'edit'" class="choose-component">
        <select
          #select4
          title="Edit a Component"
          class="form-control"
          (change)="openSideNav(select4.value, 3, templates, 'col-632', false)"
        >
          <option value="0">--Choose--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </ng-container>
    <div *ngSwitchDefault></div>

    <!-- CREATE A ROLLVER EDIT SECTION -->
    <div *ngIf="edit && templates[3].typeOf !== 'edit'" class="edit-component text-center">
      <div class="edit-existing">
        <a
          tabindex="0"
          (click)="openSideNav(templates[3].typeOf, 3, templates, 'col-632', true)"
          (keyup.enter)="openSideNav(templates[3].typeOf, 3, templates, 'col-632', true)"
          >Edit Component</a
        >
        <div class="edit-or">- OR -</div>
        <select
          #select4
          title="Choose a Component"
          class="form-control"
          (change)="openSideNav(select4.value, 3, templates, 'col-632', false)"
        >
          <option value="0">--Choose New--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div
    class="col-6 col-md-4 col-xl-2 relative"
    style="margin-bottom: 10px"
    [ngClass]="templates[4].flushed ? 'flushed' : 'no-flush'"
    [ngSwitch]="templates[4].typeOf"
  >
    <cta *ngSwitchCase="'cta'" [cta]="templates[4]" style="width: 100%"></cta>
    <image-block *ngSwitchCase="'image'" [imgblock]="templates[4]"></image-block>
    <app-feedback *ngSwitchCase="'feedback'" [feed]="templates[4]"></app-feedback>
    <showcase
      *ngSwitchCase="'showcase'"
      [showcase]="templates[4]"
      [dynamic]="true"
      [slideCount]="2"
    ></showcase>
    <text-block *ngSwitchCase="'text'" [textBlock]="templates[4]"></text-block>
    <topic-search *ngSwitchCase="'topic'" [topicSearch]="templates[4]"></topic-search>

    <ng-container *ngIf="edit">
      <div *ngSwitchCase="'edit'" class="choose-component">
        <select
          #select5
          title="Edit a Component"
          class="form-control"
          (change)="openSideNav(select5.value, 4, templates, 'col-632', false)"
        >
          <option value="0">--Choose--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </ng-container>
    <div *ngSwitchDefault></div>

    <!-- CREATE A ROLLVER EDIT SECTION -->
    <div *ngIf="edit && templates[4].typeOf !== 'edit'" class="edit-component text-center">
      <div class="edit-existing">
        <a
          tabindex="0"
          (click)="openSideNav(templates[4].typeOf, 4, templates, 'col-632', true)"
          (keyup.enter)="openSideNav(templates[4].typeOf, 4, templates, 'col-632', true)"
          >Edit Component</a
        >

        <div class="edit-or">- OR -</div>
        <select
          #select5
          title="Choose a Component"
          class="form-control"
          (change)="openSideNav(select5.value, 4, templates, 'col-632', false)"
        >
          <option value="0">--Choose New--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div
    class="col-6 col-md-4 col-xl-2 relative"
    style="margin-bottom: 10px"
    [ngClass]="templates[5].flushed ? 'flushed' : 'no-flush'"
    [ngSwitch]="templates[5].typeOf"
  >
    <cta *ngSwitchCase="'cta'" [cta]="templates[5]" style="width: 100%"></cta>
    <image-block *ngSwitchCase="'image'" [imgblock]="templates[5]"></image-block>
    <app-feedback *ngSwitchCase="'feedback'" [feed]="templates[5]"></app-feedback>
    <showcase
      *ngSwitchCase="'showcase'"
      [showcase]="templates[5]"
      [dynamic]="true"
      [slideCount]="2"
    ></showcase>
    <text-block *ngSwitchCase="'text'" [textBlock]="templates[5]"></text-block>
    <topic-search *ngSwitchCase="'topic'" [topicSearch]="templates[5]"></topic-search>

    <ng-container *ngIf="edit">
      <div *ngSwitchCase="'edit'" class="choose-component">
        <select
          #select6
          title="Edit a Component"
          class="form-control"
          (change)="openSideNav(select6.value, 5, templates, 'col-632', false)"
        >
          <option value="0">--Choose--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </ng-container>
    <div *ngSwitchDefault></div>

    <!-- CREATE A ROLLVER EDIT SECTION -->
    <div *ngIf="edit && templates[5].typeOf !== 'edit'" class="edit-component text-center">
      <div class="edit-existing">
        <a
          tabindex="0"
          (click)="openSideNav(templates[5].typeOf, 5, templates, 'col-632', true)"
          (keyup.enter)="openSideNav(templates[5].typeOf, 5, templates, 'col-632', true)"
        >
          Edit Component
        </a>

        <div class="edit-or">- OR -</div>
        <select
          #select6
          title="Choose a Component"
          class="form-control"
          (change)="openSideNav(select6.value, 5, templates, 'col-632', false)"
        >
          <option value="0">--Choose New--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>
